import {
  FulfillmentRestriction,
  ShippingRestrictions,
} from '@adapters/bigcommerce/types/product';
import { canPickupAtStore } from '@utils/fulfillment';

export const determineStorePickupRestriction = ({
  storeUID,
  restrictionLevel,
  defaultRestriction = true,
  fulfillmentRestriction,
  mecStoreId,
}: {
  storeUID: string | null;
  restrictionLevel?: ShippingRestrictions['restriction_level'] | null;
  defaultRestriction?: boolean | null;
  fulfillmentRestriction?: FulfillmentRestriction | null;
  mecStoreId?: string | null;
}) => {
  if (process.env.NEXT_PUBLIC_ENABLE_LOGGING === 'true') {
    console.log('determineStorePickupRestriction', {
      storeUID,
      restrictionLevel,
    });
  }
  if (!storeUID) {
    return defaultRestriction;
  }
  if (
    fulfillmentRestriction &&
    !canPickupAtStore(fulfillmentRestriction, mecStoreId)
  ) {
    return true;
  }
  return storeUID.includes('hbc-') && ['R10'].includes(restrictionLevel || '');
};
